export const LOADING_BOOKING_START = "LOADING_BOOKING_START";
export const LOADING_BOOKING_FINISH = "LOADING_BOOKING_FINISH";
export const SET_CURRENT_BOOKING = "SET_CURRENT_BOOKING";
export const RESET_CURRENT_BOOKING = "RESET_CURRENT_BOOKING";
export const UPDATE_CURRENT_BOOKING = "UPDATE_CURRENT_BOOKING";
